import React, { Component } from 'react';
import '../global';
import { connect } from 'react-redux';
import { getBookmarks } from '../actions';
import SquarePost from '../../components/square-post';
import ProtocolRow from '../../components/protocol-row';
import Loading from '../../components/loading-component';
import OpinionInfo from '../../opinions/components/opinion/info';
import OpinionFiles from '../../opinions/components/opinion/files';
import EventBox from '../../components/events-box';

class Bookmarks extends Component {

	constructor( props ) {
		super( props );
		this.state = {
			activeTab: 'Articles'
		};
	}

	setActiveTab( tab ) {
		this.setState( { activeTab: tab } );
	}

	componentDidMount() {
		this.props.getBookmarks();
	}

	renderContent() {
		const { userBookmarks } = this.props;
		const { activeTab } = this.state;

		// Show loading state while fetching bookmarks
		if ( !userBookmarks.bookmarks ) {
			return (<div className="bookmarks-loading">
					<Loading
						amount={ activeTab === 'Articles' || activeTab === 'Events'
						         ? 3
						         : 5 }
						height={ activeTab === 'Articles' || activeTab === 'Events'
						         ? 200
						         : 100 }
						width={ activeTab === 'Articles' || activeTab === 'Events'
						        ? 400
						        : '100%' }
						margin={ 5 }
						flex={ true }
					/>
				</div>
			);
		}

		if ( activeTab === 'Articles' ) {
			const articles = userBookmarks.bookmarks.filter( post => post.post_type === 'post' );

			if ( articles.length === 0 ) {
				return (<div className="no-bookmarks-message">
						<p>No bookmarked articles yet</p>
					</div>
				);
			}

			return (<div className="bookmark-posts">
					{ articles.map( post => (
						<SquarePost key={ post.ID } post={ post }/>
					) ) }
				</div>
			);
		} else if ( activeTab === 'Events' ) {
			const events = userBookmarks.bookmarks.filter( post => post.post_type === 'event' );

			if ( events.length === 0 ) {
				return (<div className="no-bookmarks-message">
						<p>No bookmarked events yet</p>
					</div>
				);
			}

			return (<div className="bookmark-posts events-grid">
					{ events.map( event => (
						<EventBox key={ event.ID } event={ event }/>
					) ) }
				</div>
			);
		} else if ( activeTab === 'Protocols' ) {
			const protocols = userBookmarks.bookmarks.filter( post => post.post_type === 'protocol' || post.post_type === 'traditional-protocol' );

			if ( protocols.length === 0 ) {
				return (<div className="no-bookmarks-message">
						<p>No bookmarked protocols yet</p>
					</div>
				);
			}

			return (<div className="bookmarks-list">
					{ protocols.map( post => (
						<ProtocolRow key={ post.ID } post={ post }
						             entryContent={ false }
						             isTraditional={ post.post_type === 'traditional-protocol' }/>
					) ) }
				</div>
			);
		} else { // Opinions
			const opinions = userBookmarks.bookmarks.filter( post => post.post_type === 'opinion' ); // Assuming 'opinion' is the post_type

			if ( opinions.length === 0 ) {
				return (<div className="no-bookmarks-message">
						<p>No bookmarked opinions yet</p>
					</div>
				);
			}

			return (<div> {/* Or a different class if needed */ }
					{ opinions.map( post => (
						<div className="two-col-content-panel opinions-list">
							<OpinionInfo key={ post.ID } opinion={ post }/>
							<OpinionFiles files={ post.files } id={ post.ID }
							              permalink={ post.permalink }
							              title={ post.title }/>
						</div>
					) ) }
				</div>
			);
		}
	}

	render() {
		const tabs = ['Articles', 'Events', 'Protocols', 'Opinions'];

		return (<div className="bookmarks-container">
				<ul className="nav nav-tabs">
					{ tabs.map( ( tab ) => (<li
							key={ tab }
							onClick={ () => this.setActiveTab( tab ) }
							className={ this.state.activeTab === tab
							            ? 'active'
							            : '' }
						>
							{ tab }
						</li>
					) ) }
				</ul>
				{ this.renderContent() }
			</div>
		);
	}
}

function mapStateToProps( { userBookmarks } ) {
	return { userBookmarks };
}

export default connect( mapStateToProps, { getBookmarks } )( Bookmarks );

